var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15725 6.31284H7.37693V5.12596H9.15725C9.62943 5.12596 10.0823 4.93839 10.4161 4.60451C10.75 4.27064 10.9376 3.8178 10.9376 3.34563C10.9376 2.87346 10.75 2.42062 10.4161 2.08675C10.0823 1.75287 9.62943 1.5653 9.15725 1.5653H7.37693V0.378418H9.15725C9.94421 0.378418 10.6989 0.691034 11.2554 1.24749C11.8119 1.80395 12.1245 2.55868 12.1245 3.34563C12.1245 4.13258 11.8119 4.88731 11.2554 5.44377C10.6989 6.00023 9.94421 6.31284 9.15725 6.31284ZM5.00316 6.31284H3.22283C2.43587 6.31284 1.68115 6.00023 1.12469 5.44377C0.568231 4.88731 0.255615 4.13258 0.255615 3.34563C0.255615 2.55868 0.568231 1.80395 1.12469 1.24749C1.68115 0.691034 2.43587 0.378418 3.22283 0.378418H5.00316V1.5653H3.22283C2.75066 1.5653 2.29782 1.75287 1.96395 2.08675C1.63007 2.42062 1.4425 2.87346 1.4425 3.34563C1.4425 3.8178 1.63007 4.27064 1.96395 4.60451C2.29782 4.93839 2.75066 5.12596 3.22283 5.12596H5.00316V6.31284ZM9.15725 3.93907H3.22283V2.75219H9.15725V3.93907Z",
    fill: "#8661D1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB1);
export default __webpack_public_path__ + "static/media/b1.af3256e9bf934adefe5a3edd624f6fd4.svg";
export { ForwardRef as ReactComponent };